import { SEO_TOOLS_NAMES, getSeoToolIconUrl, getSeoToolUrl } from './seo-tools-raw'

export interface ISeoTool {
  icon: string
  title: string
  desc: string
  link: string
  tool: any
}

export const seoTools: { [key: string]: ISeoTool } = {
  [SEO_TOOLS_NAMES.METRONOME]: {
    icon: getSeoToolIconUrl(SEO_TOOLS_NAMES.METRONOME),
    title: SEO_TOOLS_NAMES.METRONOME,
    desc: 'Get in rhythm with our digital metronome',
    link: getSeoToolUrl(SEO_TOOLS_NAMES.METRONOME),
    tool: () => import('./tools/Metronome/Metronome'),
  },
  [SEO_TOOLS_NAMES.CIRCLE_OF_FIFTHS]: {
    icon: getSeoToolIconUrl(SEO_TOOLS_NAMES.CIRCLE_OF_FIFTHS),
    title: SEO_TOOLS_NAMES.CIRCLE_OF_FIFTHS,
    desc: 'Easily master music harmony with our interactive Circle of Fifths tool',
    link: getSeoToolUrl(SEO_TOOLS_NAMES.CIRCLE_OF_FIFTHS),
    tool: () => import('./tools/CircleOfFifths/CircleOfFifths'),
  },
  [SEO_TOOLS_NAMES.CHORD_FINDER]: {
    icon: getSeoToolIconUrl(SEO_TOOLS_NAMES.CHORD_FINDER),
    title: SEO_TOOLS_NAMES.CHORD_FINDER,
    desc: 'Discover piano and guitar chords instantly with our Chord Finder tool',
    link: getSeoToolUrl(SEO_TOOLS_NAMES.CHORD_FINDER),
    tool: () => import('./tools/ChordFinder/ChordFinder'),
  },
  [SEO_TOOLS_NAMES.NOTE_FINDER]: {
    icon: getSeoToolIconUrl(SEO_TOOLS_NAMES.NOTE_FINDER),
    title: SEO_TOOLS_NAMES.NOTE_FINDER,
    desc: 'Explore and master piano notes with the Note Finder tool for musicians',
    link: getSeoToolUrl(SEO_TOOLS_NAMES.NOTE_FINDER),
    tool: () => import('./tools/NoteFinder/NoteFinder'),
  },
  [SEO_TOOLS_NAMES.SCALE_FINDER]: {
    icon: getSeoToolIconUrl(SEO_TOOLS_NAMES.SCALE_FINDER),
    title: SEO_TOOLS_NAMES.SCALE_FINDER,
    desc: 'Find music scales fast: your go-to Scale Finder tool',
    link: getSeoToolUrl(SEO_TOOLS_NAMES.SCALE_FINDER),
    tool: () => import('./tools/ScaleFinder/ScaleFinder'),
  },
  [SEO_TOOLS_NAMES.PIANO_SCALES]: {
    icon: getSeoToolIconUrl(SEO_TOOLS_NAMES.PIANO_SCALES),
    title: SEO_TOOLS_NAMES.PIANO_SCALES,
    desc: 'Discover Your Musical Range',
    link: getSeoToolUrl(SEO_TOOLS_NAMES.PIANO_SCALES),
    tool: () => import('./tools/PianoScales/PianoScales'),
  },
  [SEO_TOOLS_NAMES.GUITAR_SCALES]: {
    icon: getSeoToolIconUrl(SEO_TOOLS_NAMES.GUITAR_SCALES),
    title: SEO_TOOLS_NAMES.GUITAR_SCALES,
    desc: 'Discover Your Musical Range',
    link: getSeoToolUrl(SEO_TOOLS_NAMES.GUITAR_SCALES),
    tool: () => import('./tools/GuitarScales/GuitarScales'),
  },
  [SEO_TOOLS_NAMES.SONG_STRUCTURE_GENERATOR]: {
    icon: getSeoToolIconUrl(SEO_TOOLS_NAMES.SONG_STRUCTURE_GENERATOR),
    title: SEO_TOOLS_NAMES.SONG_STRUCTURE_GENERATOR,
    desc: 'Create a unique song structure with ease',
    link: getSeoToolUrl(SEO_TOOLS_NAMES.SONG_STRUCTURE_GENERATOR),
    tool: () => import('../widgets/SongStructureTool/SongStructureTool'),
  },
  [SEO_TOOLS_NAMES.SONG_IDEAS_GENERATOR]: {
    icon: getSeoToolIconUrl(SEO_TOOLS_NAMES.SONG_IDEAS_GENERATOR),
    title: SEO_TOOLS_NAMES.SONG_IDEAS_GENERATOR,
    desc: 'Find thousands of song ideas in seconds',
    link: getSeoToolUrl(SEO_TOOLS_NAMES.SONG_IDEAS_GENERATOR),
    tool: () => import('../widgets/SongIdeasTool/SongIdeasTool'),
  },
  // [SEO_TOOLS_NAMES.BACKING_TRACK_GENERATOR]: {
  //   icon: getSeoToolIconUrl(SEO_TOOLS_NAMES.BACKING_TRACK_GENERATOR),
  //   title: SEO_TOOLS_NAMES.BACKING_TRACK_GENERATOR,
  //   desc: 'Get in rhythm with our digital metronome',
  //   link: getSeoToolUrl(SEO_TOOLS_NAMES.BACKING_TRACK_GENERATOR),
  //   tool: BackingTrackGenerator,
  // },
  [SEO_TOOLS_NAMES.DRUM_MACHINE]: {
    icon: getSeoToolIconUrl(SEO_TOOLS_NAMES.DRUM_MACHINE),
    title: SEO_TOOLS_NAMES.DRUM_MACHINE,
    desc: 'Create your custom drum beats with our online Drum Machine',
    link: getSeoToolUrl(SEO_TOOLS_NAMES.DRUM_MACHINE),
    tool: () => import('./tools/DrumMachine/DrumMachine'),
  },
  [SEO_TOOLS_NAMES.PRINTABLE_STAFF_PAPER]: {
    icon: getSeoToolIconUrl(SEO_TOOLS_NAMES.PRINTABLE_STAFF_PAPER),
    title: SEO_TOOLS_NAMES.PRINTABLE_STAFF_PAPER,
    desc: 'Quickly create and download your blank music sheets in PDF',
    link: getSeoToolUrl(SEO_TOOLS_NAMES.PRINTABLE_STAFF_PAPER),
    tool: () => import('./tools/PrintableStaffPaper/PrintableStaffPaper'),
  },
}

export const seoToolsGroups = {
  General: [seoTools[SEO_TOOLS_NAMES.METRONOME], seoTools[SEO_TOOLS_NAMES.CIRCLE_OF_FIFTHS]],
  Chords: [seoTools[SEO_TOOLS_NAMES.CHORD_FINDER], seoTools[SEO_TOOLS_NAMES.NOTE_FINDER]],
  Scales: [
    seoTools[SEO_TOOLS_NAMES.SCALE_FINDER],
    seoTools[SEO_TOOLS_NAMES.PIANO_SCALES],
    seoTools[SEO_TOOLS_NAMES.GUITAR_SCALES],
  ],
  Songwriting: [seoTools[SEO_TOOLS_NAMES.SONG_STRUCTURE_GENERATOR], seoTools[SEO_TOOLS_NAMES.SONG_IDEAS_GENERATOR]],
  Other: [seoTools[SEO_TOOLS_NAMES.DRUM_MACHINE], seoTools[SEO_TOOLS_NAMES.PRINTABLE_STAFF_PAPER]],
}
